import { ActionButton } from '../ActionButton/ActionButton';
/**
 * {@docCategory Button}
 */
export var CommandButton = ActionButton;
//# sourceMappingURL=CommandButton.js.map